// Ticket-Designer: Felder auf der PDF-Vorlage platzieren.
//
// Die Vorschau ist ein SVG in Millimetern (A4, 210 x 297) und wird gezeichnet wie im PDF (FPDF):
// Text in Arial mit Schriftgröße = Größe in cm, y = Grundlinie; QR-Code als Quadrat mit Kantenlänge = Größe,
// y = Oberkante, daneben senkrecht der Ticketcode. Die Werte stehen in den versteckten Formularfeldern
// is_enabled_<feld>, <feld>_x, <feld>_y und <feld>_size (cm) und werden mit dem Formular gespeichert.
// führendes Semikolon: im Bündel steht davor clayfy.js, das ohne Semikolon endet
;(function () {
    'use strict';

    var SVG_NS = 'http://www.w3.org/2000/svg';
    var PAGE_WIDTH = 210;
    var PAGE_HEIGHT = 297;
    var POINT_IN_MM = 0.352778;
    var QR_CODE_TEXT_MM = 8 * POINT_IN_MM;
    var LIMITS = {text: {min: 0.3, max: 4}, qr: {min: 2, max: 5.5}};
    var SNAP_PX = 6;
    var DRAG_START_PX = 4;
    var ZOOM_STEPS = [0.5, 0.75, 1, 1.25, 1.5, 2, 3];
    var SAMPLE_CODE = 'ABCDEFG1234';
    var SAMPLE_ORGANIZER = 'Veranstalter GmbH, Musterstraße 1, 12345 Musterstadt';
    var SAMPLE_DESCRIPTION_LINE = 'Zweite Zeile der Beschreibung';

    function svg(name, attributes, parent) {
        var element = document.createElementNS(SVG_NS, name);
        for (var key in attributes) {
            if (attributes.hasOwnProperty(key)) {
                element.setAttribute(key, attributes[key]);
            }
        }
        if (parent) {
            parent.appendChild(element);
        }
        return element;
    }

    function svgText(parent, x, y, fontSize, content, className) {
        var text = svg('text', {x: x, y: y, 'font-size': fontSize, 'class': className || 'dnTicketdesigner-text'}, parent);
        text.textContent = content;
        return text;
    }

    function round(value) {
        return Math.round(value * 100) / 100;
    }

    function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }

    function parseNumber(text) {
        var number = parseFloat(String(text).replace(',', '.'));
        return isNaN(number) ? null : number;
    }

    // Zahlen in der Sprache der Seite anzeigen (de/fr/es/it mit Komma); Eingabe geht mit Komma und Punkt
    function formatNumber(value) {
        var comma = /^(de|fr|es|it)/.test(document.documentElement.lang || 'de');
        var text = value.toFixed(2);
        return comma ? text.replace('.', ',') : text;
    }

    function isTyping(target) {
        return target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName));
    }

    function TicketDesigner(root) {
        this.root = root;
        this.page = root.querySelector('.dnTicketdesigner-page');
        this.viewport = root.querySelector('.dnTicketdesigner-viewport');
        this.form = root.closest('form');
        this.fields = {};
        this.order = [];
        this.selected = null;
        this.action = null;
        this.zoom = 1;
        this.history = [];
        this.historyIndex = -1;
        this.savedIndex = 0;
        this.dirty = false;
        this.submitting = false;

        this.buildPage();
        this.readFields();
        this.bindList();
        this.bindCanvas();
        this.bindProperties();
        this.bindToolbar();
        this.bindKeyboard();
        this.bindForm();

        this.renderAll();
        this.remember();
        this.setDirty(false);
    }

    // --- Seite ----------------------------------------------------------------------------------------------

    TicketDesigner.prototype.buildPage = function () {
        var data = this.root.dataset;
        var defs = svg('defs', {}, this.page);
        var grid = svg('pattern', {id: 'dnTicketdesigner-grid', width: 10, height: 10, patternUnits: 'userSpaceOnUse'}, defs);
        svg('path', {d: 'M 10 0 L 0 0 0 10', 'class': 'dnTicketdesigner-grid-line'}, grid);

        svg('rect', {x: 0, y: 0, width: PAGE_WIDTH, height: PAGE_HEIGHT, 'class': 'dnTicketdesigner-paper'}, this.page);
        if (data.template) {
            svg('image', {href: data.template, x: 0, y: 0, width: PAGE_WIDTH, height: PAGE_HEIGHT, preserveAspectRatio: 'none'}, this.page);
        }
        svg('rect', {x: 0, y: 0, width: PAGE_WIDTH, height: PAGE_HEIGHT, fill: 'url(#dnTicketdesigner-grid)', 'class': 'dnTicketdesigner-grid'}, this.page);

        if (data.legalNotice === '1') {
            this.buildLegalNotice();
        }

        this.guides = svg('g', {'class': 'dnTicketdesigner-guides'}, this.page);
        this.layer = svg('g', {'class': 'dnTicketdesigner-items'}, this.page);
        this.overlay = svg('g', {'class': 'dnTicketdesigner-overlay'}, this.page);
    };

    // Rechtlicher Hinweis und Veranstalterangaben, wie TicketCustomDesign::addLegalNotice sie druckt
    TicketDesigner.prototype.buildLegalNotice = function () {
        var group = svg('g', {'class': 'dnTicketdesigner-legal'}, this.page);
        var fontSize = 7 * POINT_IN_MM;

        svg('title', {}, group).textContent = this.root.dataset.legalNoticeHint;
        svg('rect', {x: 0, y: 273, width: PAGE_WIDTH, height: PAGE_HEIGHT - 273, 'class': 'dnTicketdesigner-legal-area'}, group);
        svg('line', {x1: 10, y1: 277, x2: 200, y2: 277, 'class': 'dnTicketdesigner-legal-line'}, group);
        svgText(group, 10, 282, fontSize, this.root.dataset.legalNoticeText, 'dnTicketdesigner-legal-text');
        svgText(group, 10, 286, fontSize, SAMPLE_ORGANIZER, 'dnTicketdesigner-legal-text');
        svgText(group, 170, 282, fontSize, 'Ticketing by', 'dnTicketdesigner-legal-text');
        svgText(group, 170, 289, 4, 'DIGINIGHTS', 'dnTicketdesigner-legal-logo');
        svgText(group, 200, 275.6, 2.2, this.root.dataset.legalNoticeHint, 'dnTicketdesigner-legal-hint');
    };

    // --- Felder ---------------------------------------------------------------------------------------------

    TicketDesigner.prototype.readFields = function () {
        var self = this;

        Array.prototype.forEach.call(this.root.querySelectorAll('.dnTicketdesigner-field'), function (row) {
            var field = {
                key: row.dataset.field,
                type: row.dataset.type,
                group: row.dataset.group,
                label: row.dataset.label,
                sample: row.dataset.sample,
                row: row,
                show: row.querySelector('[data-role="show"]'),
                inputs: {
                    x: row.querySelector('[data-role="x"]'),
                    y: row.querySelector('[data-role="y"]'),
                    size: row.querySelector('[data-role="size"]')
                }
            };
            field.limits = LIMITS[field.type];
            self.createNode(field);
            self.fields[field.key] = field;
            self.order.push(field);
        });
    };

    TicketDesigner.prototype.createNode = function (field) {
        field.node = svg('g', {'class': 'dnTicketdesigner-item', 'data-field': field.key}, this.layer);
        field.hit = svg('rect', {'class': 'dnTicketdesigner-item-hit'}, field.node);

        if (field.type === 'qr') {
            field.image = svg('image', {href: this.root.dataset.qrcodeImage, x: 0, y: 0, preserveAspectRatio: 'none'}, field.node);
            field.code = svgText(field.node, 0, 0, QR_CODE_TEXT_MM, SAMPLE_CODE);
        } else {
            field.text = svgText(field.node, 0, 0, 1, '');
            field.lines = [field.sample];
            if (field.key === 'ticket_description') {
                field.lines.push(SAMPLE_DESCRIPTION_LINE);
            }
            field.tspans = field.lines.map(function (line) {
                var tspan = svg('tspan', {x: 0}, field.text);
                tspan.textContent = line;
                return tspan;
            });
        }
    };

    TicketDesigner.prototype.values = function (field) {
        return {
            show: field.show.checked,
            x: parseNumber(field.inputs.x.value) || 0,
            y: parseNumber(field.inputs.y.value) || 0,
            size: parseNumber(field.inputs.size.value) || field.limits.min
        };
    };

    // Werte in cm begrenzen: Größe wie bisher, Lage so, dass das Feld auf der Seite bleibt
    TicketDesigner.prototype.limit = function (field, x, y, size) {
        size = clamp(size, field.limits.min, field.limits.max);

        if (field.type === 'qr') {
            x = clamp(x, 0, PAGE_WIDTH / 10 - size);
            y = clamp(y, 0, PAGE_HEIGHT / 10 - size);
        } else {
            x = clamp(x, 0, PAGE_WIDTH / 10 - 0.5);
            y = clamp(y, size * 0.75, PAGE_HEIGHT / 10);
        }

        return {x: round(x), y: round(y), size: round(size)};
    };

    TicketDesigner.prototype.write = function (field, values) {
        if (values.show !== undefined) {
            field.show.checked = values.show;
        }
        ['x', 'y', 'size'].forEach(function (name) {
            if (values[name] !== undefined) {
                field.inputs[name].value = Number(values[name]).toFixed(2);
            }
        });
        this.render(field);
    };

    // --- Zeichnen -------------------------------------------------------------------------------------------

    TicketDesigner.prototype.render = function (field) {
        var values = this.values(field);
        var sizeMm = values.size * 10;
        var box;

        field.node.setAttribute('transform', 'translate(' + values.x * 10 + ' ' + values.y * 10 + ')');
        field.node.classList.toggle('is-hidden', !values.show);
        field.node.classList.toggle('is-selected', this.selected === field);
        field.row.classList.toggle('is-shown', values.show);
        field.row.classList.toggle('is-selected', this.selected === field);

        if (field.type === 'qr') {
            field.image.setAttribute('width', sizeMm);
            field.image.setAttribute('height', sizeMm);
            field.code.setAttribute('transform', 'translate(' + (sizeMm + QR_CODE_TEXT_MM) + ' ' + sizeMm + ') rotate(-90)');
            box = {x: 0, y: 0, width: sizeMm + QR_CODE_TEXT_MM, height: sizeMm};
        } else {
            field.text.setAttribute('font-size', sizeMm);
            // Zeilenabstand der Beschreibung wie im PDF: Schriftgröße + 1/5
            field.tspans.forEach(function (tspan, index) {
                tspan.setAttribute('dy', index === 0 ? 0 : sizeMm * 1.2);
            });
            box = this.textBox(field, sizeMm);
        }

        field.box = box;
        field.hit.setAttribute('x', box.x - 0.5);
        field.hit.setAttribute('y', box.y - 0.5);
        field.hit.setAttribute('width', box.width + 1);
        field.hit.setAttribute('height', box.height + 1);

        if (this.selected === field) {
            this.drawSelection();
        }
    };

    TicketDesigner.prototype.textBox = function (field, sizeMm) {
        var box = null;
        try {
            box = field.text.getBBox();
        } catch (e) {
            box = null;
        }
        if (!box || !box.width) {
            // Schätzung, falls der Browser (noch) nicht messen kann
            box = {x: 0, y: -sizeMm * 0.9, width: field.sample.length * sizeMm * 0.5, height: sizeMm * 1.15 * field.lines.length};
        }
        return {x: box.x, y: box.y, width: box.width, height: box.height};
    };

    TicketDesigner.prototype.renderAll = function () {
        var self = this;
        this.order.forEach(function (field) {
            self.render(field);
        });
        this.drawSelection();
    };

    // Pixel pro Millimeter in der aktuellen Ansicht
    TicketDesigner.prototype.scale = function () {
        return this.page.getBoundingClientRect().width / PAGE_WIDTH || 1;
    };

    TicketDesigner.prototype.toPage = function (event) {
        var rect = this.page.getBoundingClientRect();
        return {
            x: (event.clientX - rect.left) / rect.width * PAGE_WIDTH,
            y: (event.clientY - rect.top) / rect.height * PAGE_HEIGHT
        };
    };

    TicketDesigner.prototype.drawSelection = function () {
        var field = this.selected;
        var px = 1 / this.scale();
        var values;
        var rect;
        var handle;
        var label;
        var labelBox;

        while (this.overlay.firstChild) {
            this.overlay.removeChild(this.overlay.firstChild);
        }
        if (!field) {
            return;
        }

        values = this.values(field);
        rect = {
            x: values.x * 10 + field.box.x - 4 * px,
            y: values.y * 10 + field.box.y - 4 * px,
            width: field.box.width + 8 * px,
            height: field.box.height + 8 * px
        };

        svg('rect', {x: rect.x, y: rect.y, width: rect.width, height: rect.height, 'class': 'dnTicketdesigner-selection', 'vector-effect': 'non-scaling-stroke'}, this.overlay);

        label = svg('g', {'class': 'dnTicketdesigner-selection-label'}, this.overlay);
        labelBox = svg('rect', {}, label);
        var labelText = svgText(label, rect.x + 5 * px, rect.y - 6 * px, 11 * px, field.group + ' · ' + field.label, 'dnTicketdesigner-selection-label-text');
        var textBox = labelText.getBBox();
        labelBox.setAttribute('x', rect.x);
        labelBox.setAttribute('y', textBox.y - 3 * px);
        labelBox.setAttribute('width', textBox.width + 10 * px);
        labelBox.setAttribute('height', textBox.height + 6 * px);
        labelBox.setAttribute('rx', 3 * px);

        if (values.show) {
            handle = svg('rect', {
                x: rect.x + rect.width - 6 * px,
                y: rect.y + rect.height - 6 * px,
                width: 12 * px,
                height: 12 * px,
                rx: 2 * px,
                'class': 'dnTicketdesigner-handle',
                'vector-effect': 'non-scaling-stroke'
            }, this.overlay);
            svg('title', {}, handle).textContent = this.root.dataset.textResize;
        }
    };

    TicketDesigner.prototype.drawGuides = function (guides) {
        var self = this;

        while (this.guides.firstChild) {
            this.guides.removeChild(this.guides.firstChild);
        }
        (guides || []).forEach(function (guide) {
            if (guide.x !== undefined) {
                svg('line', {x1: guide.x, y1: 0, x2: guide.x, y2: PAGE_HEIGHT, 'class': 'dnTicketdesigner-guide', 'vector-effect': 'non-scaling-stroke'}, self.guides);
            } else {
                svg('line', {x1: 0, y1: guide.y, x2: PAGE_WIDTH, y2: guide.y, 'class': 'dnTicketdesigner-guide', 'vector-effect': 'non-scaling-stroke'}, self.guides);
            }
        });
    };

    // An linken Kanten und Grundlinien (QR-Codes: Oberkanten) der anderen sichtbaren Felder einrasten; Alt schaltet ab
    TicketDesigner.prototype.snap = function (field, xMm, yMm, disabled) {
        var self = this;
        var threshold = SNAP_PX / this.scale();
        var best = {x: threshold, y: threshold};
        var result = {x: xMm, y: yMm, guides: []};
        var guideX = null;
        var guideY = null;

        if (disabled) {
            return result;
        }

        this.order.forEach(function (other) {
            var values;
            if (other === field || !other.show.checked) {
                return;
            }
            values = self.values(other);
            if (Math.abs(values.x * 10 - xMm) < best.x) {
                best.x = Math.abs(values.x * 10 - xMm);
                guideX = values.x * 10;
            }
            if (other.type === field.type && Math.abs(values.y * 10 - yMm) < best.y) {
                best.y = Math.abs(values.y * 10 - yMm);
                guideY = values.y * 10;
            }
        });

        if (guideX !== null) {
            result.x = guideX;
            result.guides.push({x: guideX});
        }
        if (guideY !== null) {
            result.y = guideY;
            result.guides.push({y: guideY});
        }
        return result;
    };

    // --- Auswahl und Eigenschaften --------------------------------------------------------------------------

    TicketDesigner.prototype.select = function (field) {
        var previous = this.selected;
        this.selected = field;
        if (previous) {
            this.render(previous);
        }
        if (field) {
            this.render(field);
        }
        this.drawSelection();
        this.updateProperties();
    };

    TicketDesigner.prototype.bindProperties = function () {
        var self = this;
        var panel = this.root.querySelector('.dnTicketdesigner-properties');

        this.properties = {
            empty: panel.querySelector('.dnTicketdesigner-properties-empty'),
            form: panel.querySelector('.dnTicketdesigner-properties-form'),
            group: panel.querySelector('.dnTicketdesigner-properties-group'),
            name: panel.querySelector('.dnTicketdesigner-properties-name'),
            hidden: panel.querySelector('.dnTicketdesigner-properties-hidden'),
            show: panel.querySelector('[data-property="show"]'),
            x: panel.querySelector('[data-property="x"]'),
            y: panel.querySelector('[data-property="y"]'),
            size: panel.querySelector('[data-property="size"]'),
            hints: {
                yText: panel.querySelector('[data-hint="y-text"]'),
                yQr: panel.querySelector('[data-hint="y-qr"]'),
                size: panel.querySelector('[data-hint="size"]')
            }
        };

        this.properties.show.addEventListener('change', function () {
            if (self.selected) {
                self.toggle(self.selected, self.properties.show.checked);
            }
        });

        ['x', 'y', 'size'].forEach(function (name) {
            var input = self.properties[name];

            // beim Tippen sofort zeigen, beim Verlassen begrenzen und merken
            input.addEventListener('input', function () {
                var number = parseNumber(input.value);
                var field = self.selected;
                var values;
                if (!field || number === null) {
                    return;
                }
                values = self.values(field);
                values[name] = number;
                values = self.limit(field, values.x, values.y, values.size);
                values[name] = number;
                self.write(field, values);
            });
            input.addEventListener('change', function () {
                var field = self.selected;
                var values;
                if (!field) {
                    return;
                }
                values = self.values(field);
                self.write(field, self.limit(field, values.x, values.y, values.size));
                self.updateProperties(true);
                self.commit();
            });
            input.addEventListener('keydown', function (event) {
                var field = self.selected;
                var values;
                if (event.key === 'Enter') {
                    event.preventDefault();
                    input.blur();
                } else if (field && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
                    // Pfeiltasten im Feld: 1 mm, mit Umschalt 1 cm
                    event.preventDefault();
                    values = self.values(field);
                    values[name] += (event.key === 'ArrowUp' ? 1 : -1) * (event.shiftKey ? 1 : 0.1);
                    self.write(field, self.limit(field, values.x, values.y, values.size));
                    self.updateProperties(true);
                    self.commit();
                }
            });
        });
    };

    TicketDesigner.prototype.updateProperties = function (force) {
        var p = this.properties;
        var field = this.selected;
        var values;

        p.empty.hidden = !!field;
        p.form.hidden = !field;
        if (!field) {
            return;
        }

        values = this.values(field);
        p.group.textContent = field.group;
        p.name.textContent = field.label;
        p.show.checked = values.show;
        p.hidden.hidden = values.show;

        ['x', 'y', 'size'].forEach(function (name) {
            if (force || document.activeElement !== p[name]) {
                p[name].value = formatNumber(values[name]);
            }
        });

        p.hints.yText.hidden = field.type !== 'text';
        p.hints.yQr.hidden = field.type !== 'qr';
        p.hints.size.hidden = field.type !== 'text';
        p.hints.size.textContent = this.root.dataset.textPt.replace('%pt%', Math.round(values.size * 10 / POINT_IN_MM));
    };

    TicketDesigner.prototype.toggle = function (field, show) {
        this.write(field, {show: show});
        if (this.selected !== field) {
            this.select(field);
        } else {
            this.drawSelection();
            this.updateProperties();
        }
        this.commit();
    };

    // --- Feldliste ------------------------------------------------------------------------------------------

    TicketDesigner.prototype.bindList = function () {
        var self = this;

        this.order.forEach(function (field) {
            var row = field.row;

            field.show.addEventListener('change', function () {
                self.toggle(field, field.show.checked);
            });

            row.addEventListener('keydown', function (event) {
                if (event.target === row && (event.key === 'Enter' || event.key === ' ')) {
                    event.preventDefault();
                    self.select(field);
                }
            });

            // Klick wählt aus, Ziehen auf das Ticket blendet ein und setzt das Feld an die Stelle
            row.addEventListener('pointerdown', function (event) {
                var start;
                var ghost = null;

                if (event.button !== 0 || event.target.closest('.dnTicketdesigner-switch')) {
                    return;
                }
                start = {x: event.clientX, y: event.clientY};
                row.setPointerCapture(event.pointerId);

                function move(e) {
                    if (!ghost && Math.abs(e.clientX - start.x) + Math.abs(e.clientY - start.y) > DRAG_START_PX) {
                        ghost = document.createElement('div');
                        ghost.className = 'dnTicketdesigner-ghost';
                        ghost.textContent = field.group + ' · ' + field.label;
                        document.body.appendChild(ghost);
                        self.root.classList.add('is-draggingField');
                    }
                    if (ghost) {
                        ghost.style.left = e.clientX + 'px';
                        ghost.style.top = e.clientY + 'px';
                        self.page.classList.toggle('is-dropTarget', self.isOverPage(e));
                    }
                }

                function end(e) {
                    row.removeEventListener('pointermove', move);
                    row.removeEventListener('pointerup', end);
                    row.removeEventListener('pointercancel', end);
                    self.page.classList.remove('is-dropTarget');
                    self.root.classList.remove('is-draggingField');

                    if (!ghost) {
                        self.select(field);
                        return;
                    }
                    ghost.parentNode.removeChild(ghost);
                    if (e.type === 'pointerup' && self.isOverPage(e)) {
                        self.place(field, self.toPage(e));
                    }
                }

                row.addEventListener('pointermove', move);
                row.addEventListener('pointerup', end);
                row.addEventListener('pointercancel', end);
            });
        });
    };

    TicketDesigner.prototype.isOverPage = function (event) {
        var rect = this.page.getBoundingClientRect();
        return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
    };

    // Feld einblenden und mittig unter den Zeiger setzen
    TicketDesigner.prototype.place = function (field, point) {
        var values;
        this.write(field, {show: true});
        values = this.values(field);
        this.write(field, this.limit(
            field,
            (point.x - field.box.x - field.box.width / 2) / 10,
            (point.y - field.box.y - field.box.height / 2) / 10,
            values.size
        ));
        this.select(field);
        this.commit();
    };

    // --- Ziehen und Größe ändern auf dem Ticket -------------------------------------------------------------

    TicketDesigner.prototype.bindCanvas = function () {
        var self = this;

        this.page.addEventListener('pointerdown', function (event) {
            var handle = event.target.closest('.dnTicketdesigner-handle');
            var item = event.target.closest('.dnTicketdesigner-item');

            if (event.button !== 0) {
                return;
            }
            if (handle && self.selected) {
                self.action = self.startResize(self.selected, event);
            } else if (item && !item.classList.contains('is-hidden')) {
                self.select(self.fields[item.getAttribute('data-field')]);
                self.action = self.startDrag(self.selected, event);
            } else {
                self.select(null);
                return;
            }
            event.preventDefault();
            self.page.setPointerCapture(event.pointerId);
        });

        this.page.addEventListener('pointermove', function (event) {
            if (self.action) {
                self.action.move(event);
            }
        });

        ['pointerup', 'pointercancel'].forEach(function (type) {
            self.page.addEventListener(type, function () {
                if (self.action) {
                    self.action.end();
                    self.action = null;
                }
            });
        });

        // Griffe und Beschriftung behalten ihre Pixelgröße, wenn sich die Ansicht ändert
        if (window.ResizeObserver) {
            new ResizeObserver(function () {
                self.drawSelection();
            }).observe(this.page);
        }
    };

    TicketDesigner.prototype.startDrag = function (field, event) {
        var self = this;
        var start = this.toPage(event);
        var origin = this.values(field);
        var moved = false;

        this.root.classList.add('is-dragging');

        return {
            move: function (e) {
                var point = self.toPage(e);
                var snapped = self.snap(field, origin.x * 10 + point.x - start.x, origin.y * 10 + point.y - start.y, e.altKey);
                moved = true;
                self.write(field, self.limit(field, snapped.x / 10, snapped.y / 10, origin.size));
                self.drawGuides(snapped.guides);
                self.updateProperties();
            },
            end: function () {
                self.root.classList.remove('is-dragging');
                self.drawGuides([]);
                if (moved) {
                    self.commit();
                }
            }
        };
    };

    // Ecke ziehen: die größere Änderung von Breite und Höhe zählt; die Oberkante bleibt stehen
    TicketDesigner.prototype.startResize = function (field, event) {
        var self = this;
        var start = this.toPage(event);
        var origin = this.values(field);
        var box = field.box;
        var top = origin.y * 10 + box.y;
        var resized = false;

        this.root.classList.add('is-resizing');

        return {
            move: function (e) {
                var point = self.toPage(e);
                var dx = point.x - start.x;
                var dy = point.y - start.y;
                var size;
                var y;

                if (field.type === 'qr') {
                    size = origin.size + Math.max(dx, dy) / 10;
                    y = origin.y;
                } else {
                    size = origin.size * Math.max((box.width + dx) / box.width, (box.height + dy) / box.height);
                    size = clamp(size, field.limits.min, field.limits.max);
                    y = (top - box.y * size / origin.size) / 10;
                }
                resized = true;
                self.write(field, self.limit(field, origin.x, y, size));
                self.updateProperties();
            },
            end: function () {
                self.root.classList.remove('is-resizing');
                if (resized) {
                    self.commit();
                }
            }
        };
    };

    // --- Werkzeugleiste, Tastatur, Verlauf ------------------------------------------------------------------

    TicketDesigner.prototype.bindToolbar = function () {
        var self = this;
        var toolbar = this.root.querySelector('.dnTicketdesigner-toolbar');

        this.tools = {
            zoom: toolbar.querySelector('[data-action="zoom-fit"]'),
            grid: toolbar.querySelector('[data-action="grid"]'),
            undo: toolbar.querySelector('[data-action="undo"]'),
            redo: toolbar.querySelector('[data-action="redo"]'),
            status: toolbar.querySelector('.dnTicketdesigner-status')
        };

        toolbar.addEventListener('click', function (event) {
            var button = event.target.closest('[data-action]');
            var index = ZOOM_STEPS.indexOf(self.zoom);
            if (!button) {
                return;
            }
            switch (button.getAttribute('data-action')) {
                case 'zoom-in':
                    self.setZoom(ZOOM_STEPS[Math.min(ZOOM_STEPS.length - 1, index + 1)]);
                    break;
                case 'zoom-out':
                    self.setZoom(ZOOM_STEPS[Math.max(0, index - 1)]);
                    break;
                case 'zoom-fit':
                    self.setZoom(1);
                    break;
                case 'grid':
                    var on = self.root.classList.toggle('is-gridHidden') === false;
                    button.classList.toggle('is-active', on);
                    button.setAttribute('aria-pressed', on ? 'true' : 'false');
                    break;
                case 'undo':
                    self.undo();
                    break;
                case 'redo':
                    self.redo();
                    break;
            }
        });
    };

    TicketDesigner.prototype.setZoom = function (zoom) {
        this.zoom = zoom;
        this.page.style.width = zoom * 100 + '%';
        this.tools.zoom.textContent = Math.round(zoom * 100) + ' %';
        this.root.classList.toggle('is-zoomed', zoom > 1);
        this.drawSelection();
    };

    TicketDesigner.prototype.bindKeyboard = function () {
        var self = this;
        var arrows = {ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1]};
        var nudged = false;

        document.addEventListener('keydown', function (event) {
            var field = self.selected;
            var key = event.key;
            var mod = event.metaKey || event.ctrlKey;
            var values;
            var step;

            if (isTyping(event.target) || document.querySelector('.modal.show')) {
                return;
            }
            if (mod && (key === 'z' || key === 'Z')) {
                event.preventDefault();
                if (event.shiftKey) {
                    self.redo();
                } else {
                    self.undo();
                }
                return;
            }
            if (mod && (key === 'y' || key === 'Y')) {
                event.preventDefault();
                self.redo();
                return;
            }
            if (!field) {
                return;
            }
            if (arrows[key]) {
                event.preventDefault();
                values = self.values(field);
                step = event.shiftKey ? 1 : 0.1;
                self.write(field, self.limit(field, values.x + arrows[key][0] * step, values.y + arrows[key][1] * step, values.size));
                self.updateProperties();
                nudged = true;
            } else if (key === 'Delete' || key === 'Backspace') {
                event.preventDefault();
                self.toggle(field, false);
            } else if (key === 'Escape') {
                self.select(null);
            }
        });

        // Verschieben mit Pfeiltasten als ein Schritt im Verlauf, sobald die Taste losgelassen wird
        document.addEventListener('keyup', function (event) {
            if (nudged && arrows[event.key]) {
                nudged = false;
                self.commit();
            }
        });
    };

    TicketDesigner.prototype.snapshot = function () {
        return this.order.map(function (field) {
            return [field.show.checked, field.inputs.x.value, field.inputs.y.value, field.inputs.size.value];
        });
    };

    TicketDesigner.prototype.remember = function () {
        var snapshot = this.snapshot();
        var current = this.history[this.historyIndex];

        if (current && JSON.stringify(current) === JSON.stringify(snapshot)) {
            return false;
        }
        this.history = this.history.slice(0, this.historyIndex + 1);
        this.history.push(snapshot);
        this.historyIndex = this.history.length - 1;
        if (this.savedIndex > this.historyIndex) {
            this.savedIndex = -1;
        }
        this.updateHistory();
        return true;
    };

    TicketDesigner.prototype.commit = function () {
        if (this.remember()) {
            this.setDirty(this.historyIndex !== this.savedIndex);
        }
    };

    TicketDesigner.prototype.restore = function (index) {
        var self = this;
        var snapshot = this.history[index];

        this.historyIndex = index;
        this.order.forEach(function (field, i) {
            field.show.checked = snapshot[i][0];
            field.inputs.x.value = snapshot[i][1];
            field.inputs.y.value = snapshot[i][2];
            field.inputs.size.value = snapshot[i][3];
        });
        this.renderAll();
        this.updateProperties(true);
        this.updateHistory();
        this.setDirty(this.historyIndex !== this.savedIndex);
    };

    TicketDesigner.prototype.undo = function () {
        if (this.historyIndex > 0) {
            this.restore(this.historyIndex - 1);
        }
    };

    TicketDesigner.prototype.redo = function () {
        if (this.historyIndex < this.history.length - 1) {
            this.restore(this.historyIndex + 1);
        }
    };

    TicketDesigner.prototype.updateHistory = function () {
        this.tools.undo.disabled = this.historyIndex <= 0;
        this.tools.redo.disabled = this.historyIndex >= this.history.length - 1;
    };

    // --- Speichern ------------------------------------------------------------------------------------------

    TicketDesigner.prototype.bindForm = function () {
        var self = this;

        this.preview = document.getElementById('ticket-design-preview');
        this.previewLabel = this.preview ? this.preview.querySelector('.dnButton-text').textContent : '';

        if (this.preview) {
            this.preview.addEventListener('click', function (event) {
                if (self.dirty) {
                    event.preventDefault();
                }
            });
        }

        if (this.form) {
            // Name oder neue Vorlage gelten ebenfalls als ungespeicherte Änderung
            this.form.addEventListener('input', function (event) {
                if (!self.root.contains(event.target)) {
                    self.setDirty(true);
                }
            });
            this.form.addEventListener('change', function (event) {
                if (!self.root.contains(event.target)) {
                    self.setDirty(true);
                }
            });
            this.form.addEventListener('submit', function () {
                self.submitting = true;
            });
        }

        window.addEventListener('beforeunload', function (event) {
            if (self.dirty && !self.submitting) {
                event.preventDefault();
                event.returnValue = self.root.dataset.textLeave;
                return self.root.dataset.textLeave;
            }
        });
    };

    TicketDesigner.prototype.setDirty = function (dirty) {
        var data = this.root.dataset;

        this.dirty = dirty;
        this.tools.status.textContent = dirty ? data.textUnsaved : data.textSaved;
        this.tools.status.classList.toggle('is-dirty', dirty);

        if (this.preview) {
            this.preview.classList.toggle('dnTicketdesigner-preview-disabled', dirty);
            this.preview.setAttribute('aria-disabled', dirty ? 'true' : 'false');
            this.preview.querySelector('.dnButton-text').textContent = dirty ? data.textPreviewDirty : this.previewLabel;
        }
    };

    function init() {
        Array.prototype.forEach.call(document.querySelectorAll('.dnTicketdesigner'), function (root) {
            if (!root.ticketDesigner) {
                root.ticketDesigner = new TicketDesigner(root);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
